import { inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { DatePipe as AngularDatePipe } from '@angular/common';

const predefinedFormats = {
  scheduled: 'EEEEEE, d MMMM, HH:mm',
  scheduleTable: 'EEE, d MMM, y,',
  eventStartDate: 'd MMMM',
  dateTimeEdit: 'yyyy-MM-ddTHH:mm',
  mediumDateDotted: 'dd.MM.yyyy',
  mediumDate: 'd MMM, y',
  shortDate: 'dd.MM',
  todayTime: 'HH:mm',
  timeslot: 'EEE HH:mm',
};

const timezones = {
  'Europe/Moscow': '+0300',
};

@Pipe({
  name: 'skyproDate',
  pure: false,
  standalone: true,
})
export class DatePipe implements PipeTransform {
  private timezoneOffset = timezones['Europe/Moscow'];
  private locale = inject(LOCALE_ID);

  transform(value: Date | string | null, format = predefinedFormats.scheduled): string | null {
    // Проверка на null/undefined
    if (value == null) {
      return null;
    }

    // Проверка на пустую строку
    if (value === '') {
      return null;
    }

    // Преобразование в Date объект
    const date = value instanceof Date ? value : new Date(value);

    // Проверка валидности даты
    if (isNaN(date.getTime())) {
      return null;
    }

    return new AngularDatePipe(this.locale, this.timezoneOffset).transform(date, this.getPredefinedFormat(format));
  }

  private getPredefinedFormat(format: string): string {
    return predefinedFormats[format] || format;
  }
}
